import actionTypes from '../constants/action-types';

const clientUploadAssets = (assets, resolve, reject) => ({
  type: actionTypes.CLIENT_UPLOAD_ASSETS,
  payload: {
    assets,
    resolve,
    reject,
  },
});

export default clientUploadAssets;
